/**
 * kult-cancel.js — Kündigungs- und Widerrufsformular (sections/kult-cancel-form.liquid, sections/kult-widerruf-form.liquid).
 * Spec: docs/requirements/2026-10-03-erklaerungen-kuendigung-widerruf-spec.md.
 *
 * 1. Bedingte Felder: Wrapper mit data-decl-when="<Radio-Name>" und data-decl-is="<Wert>" erscheinen nur bei passender
 *    Auswahl; mit data-decl-require werden die Felder darin dann Pflicht. Ohne JS bleiben sie sichtbar und optional.
 * 2. Versand: POST JSON an data-decl-endpoint (App-Proxy /apps/seminare/erklaerung, Header x-requested-with: kult-form).
 *    Antwort {ok, id, receivedAt, receivedAtText}: Formular aus, Bestätigung [data-decl-success] mit allen Angaben,
 *    Datum/Uhrzeit des Eingangs (laut Server) und Referenz-ID. 400/422 mit error und 429: Meldung am Formular.
 *    Netz- oder Serverfehler: Meldung am Formular (data-msg-fail, mit E-Mail-Adresse als Ausweg), Eingaben bleiben stehen.
 *    Kein Versand über das Shopify-Kontaktformular mehr (lief je nach Bot-Schutz auf eine weiße Prüfseite).
 * Feld-Attribute: data-decl-key (API-Feld), data-decl-api (API-Wert bei Radio/Option, sonst value),
 * data-decl-label (Zeile in der Bestätigung), data-decl-append="<Präfix>" (an data-decl-key anhängen).
 * Kein Tracking, keine Cookies; die Angaben bleiben nur im DOM dieser Seite.
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function isHidden(el, stop) {
    for (var n = el; n && n !== stop; n = n.parentElement) {
      if (n.hidden) return true;
    }
    return false;
  }

  function formatDate(value) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
    return m ? m[3] + '.' + m[2] + '.' + m[1] : value;
  }

  function initToggles(form) {
    var wraps = form.querySelectorAll('[data-decl-when]');
    if (!wraps.length) return;
    function sync() {
      Array.prototype.forEach.call(wraps, function (wrap) {
        var name = wrap.getAttribute('data-decl-when');
        var checked = null;
        Array.prototype.forEach.call(form.querySelectorAll('input[type="radio"]'), function (r) {
          if (r.name === name && r.checked) checked = r;
        });
        var show = !!checked && checked.value === wrap.getAttribute('data-decl-is');
        wrap.hidden = !show;
        if (wrap.hasAttribute('data-decl-require')) {
          Array.prototype.forEach.call(wrap.querySelectorAll('input, textarea, select'), function (field) {
            field.required = show;
          });
        }
      });
    }
    form.addEventListener('change', sync);
    sync();
  }

  function collect(root, form) {
    var data = {
      kind: root.getAttribute('data-decl-kind') || '',
      name: '',
      email: '',
      reference: '',
      contract: root.getAttribute('data-decl-contract') || '',
      details: '',
      type: null,
      reason: '',
      effective: null,
      orderDate: '',
      receivedDate: '',
      page: window.location.pathname
    };
    var rows = [];
    Array.prototype.forEach.call(form.querySelectorAll('[data-decl-key]'), function (el) {
      if (isHidden(el, form)) return;
      if (el.type === 'radio' && !el.checked) return;
      var key = el.getAttribute('data-decl-key');
      var raw = (el.value || '').trim();
      var api = raw;
      var shown = raw;
      if (el.type === 'radio') {
        api = el.getAttribute('data-decl-api') || raw;
      } else if (el.tagName === 'SELECT') {
        var opt = el.options[el.selectedIndex];
        api = opt ? opt.getAttribute('data-decl-api') || opt.value : '';
        shown = opt ? opt.text.trim() : '';
      } else if (el.type === 'date') {
        shown = formatDate(raw);
      }
      var prefix = el.getAttribute('data-decl-append');
      if (prefix) {
        if (api) data[key] = data[key] ? data[key] + '\n\n' + prefix + ': ' + api : api;
      } else if (api !== '') {
        data[key] = api;
      }
      var label = el.getAttribute('data-decl-label');
      if (label) rows.push([label, shown]);
    });
    if (data.effective === 'datum') data.effective = data.effectiveDate || null;
    delete data.effectiveDate;
    return { data: data, rows: rows };
  }

  function receivedParts(res) {
    var m = /(\d{2}\.\d{2}\.\d{4})\D+(\d{1,2}:\d{2})/.exec((res && res.receivedAtText) || '');
    if (m) return { date: m[1], time: m[2] };
    var d = res && res.receivedAt ? new Date(res.receivedAt) : new Date();
    if (isNaN(d.getTime())) d = new Date();
    return {
      date: d.toLocaleDateString('de-DE', { timeZone: 'Europe/Berlin', day: '2-digit', month: '2-digit', year: 'numeric' }),
      time: d.toLocaleTimeString('de-DE', { timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit' })
    };
  }

  function showSuccess(root, form, res, collected) {
    var box = root.querySelector('[data-decl-success]');
    if (!box) return false;
    var when = receivedParts(res);
    var text = (box.getAttribute('data-text') || '')
      .replace(/\{datum\}/g, when.date)
      .replace(/\{uhrzeit\}/g, when.time)
      .replace(/\{email\}/g, collected.data.email)
      .replace(/\{id\}/g, res.id || '');
    var textEl = box.querySelector('[data-decl-success-text]');
    if (textEl) textEl.textContent = text;
    var list = box.querySelector('[data-decl-summary]');
    if (list) {
      var empty = box.getAttribute('data-empty') || '–';
      var rows = collected.rows.concat([
        [box.getAttribute('data-label-received'), when.date + ', ' + when.time + ' Uhr'],
        [box.getAttribute('data-label-id'), res.id || '']
      ]);
      list.textContent = '';
      rows.forEach(function (row) {
        if (!row[0]) return;
        var dt = document.createElement('dt');
        var dd = document.createElement('dd');
        dt.textContent = row[0];
        dd.textContent = row[1] || empty;
        list.appendChild(dt);
        list.appendChild(dd);
      });
    }
    form.hidden = true;
    Array.prototype.forEach.call(root.querySelectorAll('[data-decl-hide-on-success]'), function (el) { el.hidden = true; });
    box.hidden = false;
    box.focus({ preventScroll: true });
    root.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });
    return true;
  }

  function init(root) {
    if (root.__kultDecl) return;
    root.__kultDecl = true;

    Array.prototype.forEach.call(root.querySelectorAll('[data-decl-print]'), function (btn) {
      btn.addEventListener('click', function () { window.print(); });
    });

    var form = root.querySelector('form');
    if (!form || !form.querySelector('[data-decl-key]')) return;
    initToggles(form);

    var endpoint = root.getAttribute('data-decl-endpoint');
    if (!endpoint || !window.fetch) return;
    var button = form.querySelector('[type="submit"]');
    var msg = form.querySelector('[data-decl-msg]');
    var busy = false;

    function setBusy(on) {
      busy = on;
      if (button) {
        button.disabled = on;
        button.setAttribute('aria-busy', on ? 'true' : 'false');
      }
    }
    function showMessage(text) {
      if (!msg) return;
      msg.textContent = text;
      msg.hidden = false;
    }
    function failed(text) {
      showMessage(text || root.getAttribute('data-msg-fail') || 'Das hat gerade nicht geklappt. Bitte versuche es gleich noch einmal.');
      setBusy(false);
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (busy) return;
      setBusy(true);
      if (msg) msg.hidden = true;
      var collected = collect(root, form);
      fetch(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'x-requested-with': 'kult-form' },
        body: JSON.stringify(collected.data)
      })
        .then(function (r) {
          return r.json().catch(function () { return null; }).then(function (json) { return { status: r.status, json: json }; });
        })
        .then(function (res) {
          if (res.json && res.json.ok && showSuccess(root, form, res.json, collected)) return;
          if (res.status === 429) {
            showMessage(root.getAttribute('data-msg-rate') || 'Bitte versuche es gleich noch einmal.');
          } else if ((res.status === 400 || res.status === 422) && res.json && res.json.error) {
            showMessage(res.json.error);
          } else {
            failed(res.json && res.json.error);
            return;
          }
          setBusy(false);
        })
        .catch(function () { failed(); });
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-decl]'), init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
